import React from 'react';
import { TagStyled } from './tag.styled';
import { Color, ColorEnum } from './types';

interface TagProps {
  color?: Color;
  children?: React.ReactNode | React.ReactNode[];
}

const Tag = ({ children, ...rest }: TagProps) => {
  return <TagStyled {...rest}>{children}</TagStyled>;
};

Tag.defaultProps = {
  color: ColorEnum.primary,
};

export default Tag;
